import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { TranslateService } from '@ngx-translate/core';
import { inject } from '@angular/core';

export function sortByTranslation(keyValueArray: KeyValue[]): KeyValue[] {
  const translateService = inject(TranslateService)

  return keyValueArray.sort((a, b) => {
    return translateService.instant(a.value).localeCompare(translateService.instant(b.value));
  });
}
